import { usePunditUserContext } from "@circle-react/contexts";

export const useCanCreateCourses = () => {
  const { currentCommunity } = usePunditUserContext();
  const { courses_feature_flag_enabled } = currentCommunity;
  const canCreateCourses = Boolean(courses_feature_flag_enabled);

  return {
    canCreateCourses,
  };
};
